import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnLockUnlocked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M6.813 11.531V8.72c0-3.103.78-5.625 4.687-5.625s4.688 2.344 4.688 4.687m-.938 13.125h-7.5c-3 0-3.75-.781-3.75-3.906v-1.562c0-3.126.75-3.907 3.75-3.907h7.5c3 0 3.75.781 3.75 3.906V17c0 3.125-.75 3.906-3.75 3.906"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnLockUnlocked;
